module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-left"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', [_vm._v("当前域: \n                "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'job_overview',
        params: {
          domain: _vm.domain
        }
      }
    }
  }, [_vm._v(_vm._s(this.domain))])], 1), _vm._v(" "), _c('span', [_vm._v("所属集群: "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'clusters_manage'
      }
    }
  }, [_vm._v(_vm._s(_vm.domainInfo.zkAlias))])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    运维负责人："), _c('span', [_vm._v(_vm._s(_vm.domainInfo.sysAdmin || '空'))]), _c('br'), _vm._v("\n                    开发负责人："), _c('span', [_vm._v(_vm._s(_vm.domainInfo.techAdmin || '空'))])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-warning"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-bar-right"
  }, [(_vm.isShowBarSearch) ? _c('el-autocomplete', {
    staticClass: "top-bar-search",
    attrs: {
      "prefix-icon": "el-icon-search",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "切换作业",
      "popper-class": "header-autocomplete"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.jobNameSelect),
      callback: function($$v) {
        _vm.jobNameSelect = $$v
      },
      expression: "jobNameSelect"
    }
  }) : _vm._e(), _vm._v(" "), _c('Favorites')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-536b30b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/top_bar.vue
// module id = 1408
// module chunks = 1